import dataBusReducer from './dataBus.reducer';
import userReducer from './user.reducer';
import uiReducer from './ui.reducer';

export const combinedReducers = {
    dataBus: dataBusReducer,
    user: userReducer,
    ui: uiReducer,
};
